import React, { useState } from "react";
import { Container, Card, Form, Button, Row, Col } from "react-bootstrap";
import img from '../img/get a quote.jpg';
import "./AirExportLogisticsSoftware.css";
import "./About.css";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    enquiry: "",
    preferred_date: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, message, enquiry } = formData;

    if (!name || !email || !message) {
      alert("Please fill in all required fields.");
      return;
    }

    const subject = enquiry || "New Enquiry";
    const body = `
      Name: ${name}
      Email: ${email}
      Company: ${formData.company}
      Phone: ${formData.phone}
      Preferred Date: ${formData.preferred_date}

      Message:
      ${message}
    `;

    const mailtoLink = `mailto:info@catustechnologies.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
  };

  return (
    <Container id="contact" className="py-5 space-container">
      <div className="my-3 container">
        <h2 className="text-center fade-in">
          Catus L.M.S Making Your Logistics Business Easier
        </h2>
        <hr />
        <p className="fs-4 fs-md-4 text-center">Request a tailored quote for our logistics and financial accounting software solutions. Fill out the form below, and our team will get back to you promptly.</p>
        <Col className="my-3">
          <div className="d-flex flex-column flex-lg-row justify-content-center align-items-stretch">
            {/* Image */}
            <img
              src={img}
              alt="Features Illustration"
              className="img-fluid"
              style={{ width: "100%", maxWidth: "550px", maxHeight:"85vh", borderRadius: "8px" }}
            />

            {/* Card */}
           <Card 
  className="p-4 flex-grow-1 d-flex justify-content-center align-items-center w-100" 
  style={{ maxWidth: "550px" }}
>
  <Card.Body className="my-3 w-100">
    <Card.Title className="m-1 text-center">
      <u>Please contact us via the form below.</u>
    </Card.Title>

    <Form onSubmit={handleSubmit}>
      {/* Name + Company */}
      <Row className="mb-3">
        <Form.Group as={Col} xs={12} md={6} controlId="formName">
          <Form.Label><strong>Name*</strong></Form.Label>
          <Form.Control
            type="text"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group as={Col} xs={12} md={6} controlId="formCompanyName">
          <Form.Label><strong>Company Name</strong></Form.Label>
          <Form.Control
            type="text"
            name="company"
            placeholder="Enter your company name"
            value={formData.company}
            onChange={handleChange}
          />
        </Form.Group>
      </Row>

      {/* Email + Phone */}
      <Row className="mb-3">
        <Form.Group as={Col} xs={12} md={6} controlId="formEmail">
          <Form.Label><strong>Email*</strong></Form.Label>
          <Form.Control
            type="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group as={Col} xs={12} md={6} controlId="formPhone">
          <Form.Label><strong>Phone Number*</strong></Form.Label>
          <Form.Control
            type="tel"
            name="phone"
            placeholder="Enter your phone number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </Form.Group>
      </Row>

      {/* Enquiry + Date */}
      <Row className="mb-3">
        <Form.Group as={Col} xs={12} md={6} controlId="formEnquiryType">
          <Form.Label><strong>Type of Enquiry</strong></Form.Label>
          <Form.Control
            type="text"
            name="enquiry"
            placeholder="Type of enquiry"
            value={formData.enquiry}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group as={Col} xs={12} md={6} controlId="formPreferredDate">
          <Form.Label><strong>Preferred Date</strong></Form.Label>
          <Form.Control
            type="date"
            name="preferred_date"
            value={formData.preferred_date}
            onChange={handleChange}
          />
        </Form.Group>
      </Row>

      {/* Message */}
      <Form.Group className="mb-3" controlId="formMessage">
        <Form.Label><strong>Message*</strong></Form.Label>
        <Form.Control
          as="textarea"
          name="message"
          rows={4}
          placeholder="Your message"
          value={formData.message}
          onChange={handleChange}
          required
        />
      </Form.Group>

      {/* Submit */}
      <div className="d-grid gap-2">
        <Button variant="primary" size="md" type="submit">
          Submit Form
        </Button>
      </div>
    </Form>
  </Card.Body>
</Card>

          </div>
        </Col>
      </div>
    </Container>
  );
}
